import { Box } from "@mui/material";

interface AppLayoutHeaderWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper for the header of the app layout
 * Renders above the inner content (nav menu and page content) and wraps the header content
 */
export function AppLayoutHeaderWrapper(props: AppLayoutHeaderWrapperProps) {
  const { children } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 0,
        // TODO: most likely makes sense to force this height by the header content.
        // As this is initial PR adding placeholder components, I'm gonna leave it as is for now.
        height: "62px",
        flexShrink: 0,
      }}
    >
      {children}
    </Box>
  );
}
